import { render } from "./mped-fact-file-uploader-component.vue?vue&type=template&id=d873fe78&scoped=true"
import script from "./mped-fact-file-uploader-component.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-fact-file-uploader-component.vue?vue&type=script&setup=true&lang=js"

import "./mped-fact-file-uploader-component.vue?vue&type=style&index=0&id=d873fe78&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d873fe78"],['__file',"src/views/mped/components/mped-calculation-upload/mped-fact-file-uploader-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d873fe78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d873fe78', __exports__)) {
    api.reload('d873fe78', __exports__)
  }
  
  module.hot.accept("./mped-fact-file-uploader-component.vue?vue&type=template&id=d873fe78&scoped=true", () => {
    api.rerender('d873fe78', render)
  })

}


export default __exports__